/**
 * 获取 URL 参数
 * @param {string} key - 要获取的参数名
 * @param {string} [url] - 可选，指定要解析的 URL，不传则取当前页面 URL
 * @returns {string|null} - 参数值（不存在则返回 null）
 */
export function getUrlParam (key: string, url?: string) {
  if (!key) return null
  // 如果没传url，则取当前页面的url
  url = url || window.location.href
  try {
    const urlObj = new URL(url)
    return urlObj.searchParams.get(key)
  } catch (e) {
    console.error('URL解析失败:', e)
    return null
  }
}

/**
 * 获取所有 URL 参数
 * @param {string} [url] - 可选，指定要解析的 URL，不传则取当前页面 URL
 * @returns {Object} - 参数对象
 */
export function getAllUrlParams (url?: string) {
  url = url || window.location.href
  const paramsObj = {}
  try {
    const urlObj = new URL(url)
    for (const [key, value] of urlObj.searchParams.entries()) {
      paramsObj[key] = value
    }
  } catch (e) {
    console.error('URL解析失败:', e)
  }
  return paramsObj
}
